import React, {useEffect, useState} from "react";

import {CancelContinueButtons} from "../../Controls/CancelContinueButtons";
import {useStore} from "../../../Store";
import {PageLayoutWithGetData} from "../../Controls/PageLayout";
import {
    DataDeletionPopUp,
    DeIdentificationPopUp,
    OutsourcedProvidersPopUp,
} from "../PopUps";
import BackLink from "../../Controls/BackLink";
import {DataRequestScope} from "../../Controls/DataRequestScope";
import {useNavigate} from "react-router-dom";
import {
    Alert,
    AlertIcon,
    Box,
    Button,
    Divider,
    Heading,
    HStack,
    Switch,
    Text,
} from "@chakra-ui/react";
import {ConsumerDataRightBox} from "../../Controls/ConsumerDataRightBox";
import {formatDate} from "../../../utils/formatDate";

const InfoSection: React.FC<{ isGrey?: boolean; children: JSX.Element }> = ({
                                                                                isGrey,
                                                                                children,
                                                                            }) => (
    <Box px="48px" py={6} bg={isGrey ? "gray.100" : undefined} w="full">
        {children}
    </Box>
);

export default function DataRequest() {
    const navigate = useNavigate();

    const notRequested = "NotRequested";
    const optionalButNotConsented = "OptionalButNotConsented";
    const optionalAndConsented = "OptionalAndConsented";
    const requiredButNotConsented = "RequiredButNotConsented";
    const requiredAndConsented = "RequiredAndConsented";
    const individual = "Individual";
    const business = "Business";

    const nameOccupation = "NameOccupation";
    const contactDetails = "ContactDetails";
    const nameOccupationContactDetails = "NameOccupationContactDetails";
    const organisationProfile = "OrganisationProfile";
    const organisationContactDetails = "OrganisationContactDetails";
    const orgProfileContactDetails = "OrgProfileContactDetails";
    const accountTypeBalance = "AccountTypeBalance";
    const accountFeatures = "AccountFeatures";
    const accountBalanceDetails = "AccountBalanceDetails";
    const transDetails = "TransDetails";
    const directDebits = "DirectDebits";
    const savedPayees = "SavedPayees";

    const {data, setSelectedConsent} = useStore();

    const [rerender, setRerender] = useState(0);

    const [PopupOutsourcedProviders, setPopUpOutsourcedProviders] =
        useState(false);
    const [PopupDeIdentification, setPopupDeIdentification] = useState(false);
    const [PopupDataDeletion, setPopupDataDeletion] = useState(false);

    //
    const [selectedData, setSelectedData] = useState(false);
    const [hasRequired, setHasRequired] = useState(false);

    const [scopes] = useState(new Map());

    const [additionalUses, setAdditionalUses] = useState([]);
    const [deleteData, setDeleteData] = useState(false);

    const consent = data?.consent;
    const dataRecipient =
        data?.softwareProduct?.dataRecipientBrand?.dataRecipient;
    const softwareProductWording = data?.softwareProductWording;

    useEffect(() => {
        if (consent) {
            updateScope(
                nameOccupation,
                consent?.nameAndOccupationConsent,
                false,
                isScopeRequired(consent?.nameAndOccupationConsent)
            );
            updateScope(
                contactDetails,
                consent?.contactDetailsConsent,
                false,
                isScopeRequired(consent?.contactDetailsConsent)
            );
            updateScope(
                nameOccupationContactDetails,
                consent?.nameOccupationContactDetailsConsent,
                false,
                isScopeRequired(consent?.nameOccupationContactDetailsConsent)
            );
            updateScope(
                organisationProfile,
                consent?.organisationProfileConsent,
                false,
                isScopeRequired(consent?.organisationProfileConsent)
            );
            updateScope(
                organisationContactDetails,
                consent?.organisationContactDetailsConsent,
                false,
                isScopeRequired(consent?.organisationContactDetailsConsent)
            );
            updateScope(
                orgProfileContactDetails,
                consent?.organisationProfileAndContactDetailsConsent,
                false,
                isScopeRequired(consent?.organisationProfileAndContactDetailsConsent)
            );
            updateScope(
                accountTypeBalance,
                consent?.accountNameTypeAndBalanceConsent,
                false,
                isScopeRequired(consent?.accountNameTypeAndBalanceConsent)
            );
            updateScope(
                accountFeatures,
                consent?.accountNumbersAndFeaturesConsent,
                false,
                isScopeRequired(consent?.accountNumbersAndFeaturesConsent)
            );
            updateScope(
                accountBalanceDetails,
                consent?.accountBalanceAndDetailsConsent,
                false,
                isScopeRequired(consent?.accountBalanceAndDetailsConsent)
            );
            updateScope(
                transDetails,
                consent?.transactionDetailsConsent,
                false,
                isScopeRequired(consent?.transactionDetailsConsent)
            );
            updateScope(
                directDebits,
                consent?.directDebitsAndScheduledPaymentsConsent,
                false,
                isScopeRequired(consent?.directDebitsAndScheduledPaymentsConsent)
            );
            updateScope(
                savedPayees,
                consent?.savedPayeesConsent,
                false,
                isScopeRequired(consent?.savedPayeesConsent)
            );
            setRerender(rerender + 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onSwitchChange(scopeId: string, isSelected: boolean) {
        let existingScope = scopes.get(scopeId);

        if (existingScope) {
            updateScope(
                scopeId,
                existingScope.value,
                isSelected,
                existingScope.required
            );

            let allRequiredSelected = true; // Assume true as scopes may have zero required
            let atLeastOneOptionalSelected = false;

            scopes.forEach((scope, key) => {
                if (scope.required === true && scope.selected === false) {
                    allRequiredSelected = false;
                }
            });

            scopes.forEach((scope, key) => {
                if (scope.selected === true) {
                    atLeastOneOptionalSelected = true;
                }
            });

            setSelectedData(allRequiredSelected && atLeastOneOptionalSelected);
        }
    }

    function saveData() {
        let selectedConsent = {
            nameAndOccupationConsent: getNextConsent(scopes.get(nameOccupation)),
            contactDetailsConsent: getNextConsent(scopes.get(contactDetails)),
            nameOccupationContactDetailsConsent: getNextConsent(
                scopes.get(nameOccupationContactDetails)
            ),

            organisationProfileConsent: getNextConsent(
                scopes.get(organisationProfile)
            ),
            organisationContactDetailsConsent: getNextConsent(
                scopes.get(organisationContactDetails)
            ),
            organisationProfileAndContactDetailsConsent: getNextConsent(
                scopes.get(orgProfileContactDetails)
            ),

            accountNameTypeAndBalanceConsent: getNextConsent(
                scopes.get(accountTypeBalance)
            ),
            accountNumbersAndFeaturesConsent: getNextConsent(
                scopes.get(accountFeatures)
            ),
            accountBalanceAndDetailsConsent: getNextConsent(
                scopes.get(accountBalanceDetails)
            ),

            transactionDetailsConsent: getNextConsent(scopes.get(transDetails)),
            directDebitsAndScheduledPaymentsConsent: getNextConsent(
                scopes.get(directDebits)
            ),
            savedPayeesConsent: getNextConsent(scopes.get(savedPayees)),

            deleteMyData: deleteData,
            additionalUses: additionalUses,
        };

        setSelectedConsent(selectedConsent);

        navigate("/SelectDataHolder");
    }

    function getNextConsent(scope: any) {
        let newScopeValue = scope.value;

        if (scope.selected) {
            if (scope.value === optionalButNotConsented) {
                newScopeValue = optionalAndConsented;
            } else if (scope.value === requiredButNotConsented) {
                newScopeValue = requiredAndConsented;
            }
        }

        return newScopeValue;
    }

    function removeArrayItemOnce(arr: any[], value: any) {
        var index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }
        return arr;
    }

    function updateAdditionalUses(e: any, id: any) {
        var array = additionalUses;

        // @ts-ignore
        if (e) array.push(id);
        // @ts-ignore
        else array = removeArrayItemOnce(array, id);

        setAdditionalUses(array);
    }

    function updateScope(
        scopeId: any,
        scopeValue: any,
        isSelected: any,
        isRequired: any
    ) {
        scopes.set(scopeId, {
            value: scopeValue,
            selected: isSelected,
            required: isRequired,
        });

        if (isRequired) {
            setHasRequired(true);
        }
    }

    function isScopeRequired(scope: string) {
        return scope === requiredButNotConsented || scope === requiredAndConsented;
    }

    const shouldDisplayBackLink = !(data?.session?.startPage === "data-request");

    return (
        <PageLayoutWithGetData loading={false} hasContainerPadding={false}>
            <Box px={10} pt={5}>
                
                {shouldDisplayBackLink && <BackLink page="/DataSharingInstructions"/>}
                
                <Heading variant="pageHeading">Data Request</Heading>

                <Divider my={5}/>

                <Box mx={2}>
                    <Text>{softwareProductWording?.paragraphDataRequest}</Text>

                    <ConsumerDataRightBox dataRecipient={dataRecipient}/>

                    <Heading fontSize="sm" mb={5}>
                        Data we need
                    </Heading>

                    {/* Consents */}

                    {/* Individual */}
                    {consent?.customerType === individual ? (
                        <>
                            {/* Name and occupation */}
                            {consent?.nameAndOccupationConsent !== notRequested &&
                            consent?.nameOccupationContactDetailsConsent === notRequested ? (
                                <DataRequestScope
                                    scopeId={nameOccupation}
                                    onSwitchChange={onSwitchChange}
                                    isRequired={scopes.get(nameOccupation)?.required}
                                    title="Name and occupation"
                                    whyWeNeedIt={
                                        softwareProductWording?.whyWeNeedNameAndOccupation || ""
                                    }
                                    dataList={["Name", "Occupation"]}
                                />
                            ) : null}

                            {/* Contact details */}
                            {consent?.contactDetailsConsent !== notRequested &&
                            consent?.nameOccupationContactDetailsConsent === notRequested ? (
                                <DataRequestScope
                                    scopeId={contactDetails}
                                    onSwitchChange={onSwitchChange}
                                    isRequired={scopes.get(contactDetails)?.required}
                                    title="Contact details"
                                    whyWeNeedIt={
                                        softwareProductWording?.whyWeNeedContactDetails || ""
                                    }
                                    dataList={[
                                        "Phone",
                                        "Email address",
                                        "Mail address",
                                        "Residential address",
                                    ]}
                                />
                            ) : null}

                            {/* Name, occupation and contact details */}
                            {consent?.nameOccupationContactDetailsConsent !== notRequested ? (
                                <DataRequestScope
                                    scopeId={nameOccupationContactDetails}
                                    onSwitchChange={onSwitchChange}
                                    isRequired={
                                        scopes.get(nameOccupationContactDetails)?.required
                                    }
                                    title="Name, occupation and contact details"
                                    whyWeNeedIt={
                                        softwareProductWording?.whyWeNeedNameOccupationContactDetails ||
                                        ""
                                    }
                                    dataList={[
                                        "Name",
                                        "Occupation",
                                        "Phone",
                                        "Email address",
                                        "Mail address",
                                        "Residential address",
                                    ]}
                                />
                            ) : null}
                        </>
                    ) : null}

                    {/* Business */}
                    {consent?.customerType === business ? (
                        <>
                            {/* Organisation profile */}
                            {consent?.organisationProfileConsent !== notRequested &&
                            consent?.organisationProfileAndContactDetailsConsent ===
                            notRequested ? (
                                <DataRequestScope
                                    scopeId={organisationProfile}
                                    onSwitchChange={onSwitchChange}
                                    isRequired={scopes.get(organisationProfile)?.required}
                                    title="Organisation profile"
                                    whyWeNeedIt={
                                        softwareProductWording?.whyWeNeedOrganisationProfile || ""
                                    }
                                    dataList={[
                                        "Agent name and role",
                                        "Organisation name",
                                        "Organisation numbers (ABN or ACN)",
                                        "Charity status",
                                        "Establishment date",
                                        "Industry",
                                        "Organisation type",
                                        "Country of registration",
                                    ]}
                                />
                            ) : null}

                            {/* Organisation contact details */}
                            {consent?.organisationContactDetailsConsent !== notRequested &&
                            consent?.organisationProfileAndContactDetailsConsent ===
                            notRequested ? (
                                <DataRequestScope
                                    scopeId={organisationContactDetails}
                                    onSwitchChange={onSwitchChange}
                                    isRequired={scopes.get(organisationContactDetails)?.required}
                                    title="Organisation contact details"
                                    whyWeNeedIt={
                                        softwareProductWording?.whyWeNeedOrganisationContactDetails ||
                                        ""
                                    }
                                    dataList={[
                                        "Organisation address",
                                        "Mail address",
                                        "Phone number",
                                    ]}
                                />
                            ) : null}

                            {/* Organisation profile and contact details */}
                            {consent?.organisationProfileAndContactDetailsConsent !==
                            notRequested ? (
                                <DataRequestScope
                                    scopeId={orgProfileContactDetails}
                                    onSwitchChange={onSwitchChange}
                                    isRequired={scopes.get(orgProfileContactDetails)?.required}
                                    title="Organisation profile and contact details"
                                    whyWeNeedIt={
                                        softwareProductWording?.whyWeNeedOrganisationContactDetails ||
                                        ""
                                    }
                                    dataList={[
                                        "Agent name and role",
                                        "Organisation name",
                                        "Organisation numbers (ABN or ACN)",
                                        "Charity status",
                                        "Establishment date",
                                        "Industry",
                                        "Organisation type",
                                        "Country of registration",
                                        "Organisation address",
                                        "Mail address",
                                        "Phone number",
                                    ]}
                                />
                            ) : null}
                        </>
                    ) : null}

                    {/* Account name, type and balance */}
                    {consent?.accountNameTypeAndBalanceConsent !== notRequested &&
                    consent?.accountBalanceAndDetailsConsent === notRequested ? (
                        <DataRequestScope
                            scopeId={accountTypeBalance}
                            onSwitchChange={onSwitchChange}
                            isRequired={scopes.get(accountTypeBalance)?.required}
                            title="Account name, type and balance"
                            whyWeNeedIt={
                                softwareProductWording?.whyWeNeedTransactionDetails || ""
                            }
                            dataList={[
                                "Name of account",
                                "Type of account",
                                "Account balance",
                            ]}
                        />
                    ) : null}

                    {/* Account numbers and features  */}
                    {consent?.accountNumbersAndFeaturesConsent !== notRequested &&
                    consent?.accountBalanceAndDetailsConsent === notRequested ? (
                        <DataRequestScope
                            scopeId={accountFeatures}
                            onSwitchChange={onSwitchChange}
                            isRequired={scopes.get(accountFeatures)?.required}
                            title="Account numbers and features"
                            whyWeNeedIt={
                                softwareProductWording?.whyWeNeedAccountNumbersAndFeatures || ""
                            }
                            dataList={[
                                "Account number",
                                "Interest rates",
                                "Fees",
                                "Discounts",
                                "Account terms",
                                "Account mail address",
                            ]}
                        />
                    ) : null}

                    {/* Account balance and details */}
                    {consent?.accountBalanceAndDetailsConsent !== notRequested ? (
                        <DataRequestScope
                            scopeId={accountBalanceDetails}
                            onSwitchChange={onSwitchChange}
                            isRequired={scopes.get(accountBalanceDetails)?.required}
                            title="Account balance and details"
                            whyWeNeedIt={
                                softwareProductWording?.whyWeNeedAccountBalanceAndDetails || ""
                            }
                            dataList={[
                                "Name of account",
                                "Type of account",
                                "Account balance",
                                "Account number",
                                "Interest rates",
                                "Fees",
                                "Discounts",
                                "Account terms",
                                "Account mail address",
                            ]}
                        />
                    ) : null}

                    {/* Transaction details */}
                    {consent?.transactionDetailsConsent !== notRequested ? (
                        <DataRequestScope
                            scopeId={transDetails}
                            onSwitchChange={onSwitchChange}
                            isRequired={scopes.get(transDetails)?.required}
                            title="Transaction details"
                            whyWeNeedIt={
                                softwareProductWording?.whyWeNeedTransactionDetails || ""
                            }
                            dataList={[
                                "Incoming and outgoing transactions",
                                "Amounts",
                                "Dates",
                                "Descriptions of transactions",
                                "Who you've sent money to and recieved from (e.g. their name)",
                            ]}
                        />
                    ) : null}

                    {/* Direct debits and scheduled payments */}
                    {consent?.directDebitsAndScheduledPaymentsConsent !== notRequested ? (
                        <DataRequestScope
                            scopeId={directDebits}
                            onSwitchChange={onSwitchChange}
                            isRequired={scopes.get(directDebits)?.required}
                            title="Direct debits and scheduled payments"
                            whyWeNeedIt={
                                softwareProductWording?.whyWeNeedDirectDebitsAndScheduledPayments ||
                                ""
                            }
                            dataList={["Direct debits", "Scheduled payments"]}
                        />
                    ) : null}

                    {/* Saved payees */}
                    {consent?.savedPayeesConsent !== notRequested ? (
                        <DataRequestScope
                            scopeId={savedPayees}
                            onSwitchChange={onSwitchChange}
                            isRequired={scopes.get(savedPayees)?.required}
                            title="Saved payees"
                            whyWeNeedIt={softwareProductWording?.whyWeNeedSavedPayees || ""}
                            dataList={[
                                "Names and details of accounts you have saved (e.g. their BSB and Account Number, BPay CRN and Biller code, or NPP PayID)",
                            ]}
                        />
                    ) : null}
                </Box>
            </Box>
            {Boolean(
                (softwareProductWording &&
                    softwareProductWording?.softwareProductWordingAdditionalUses?.length >
                    0) ||
                (softwareProductWording &&
                    softwareProductWording?.softwareProductWordingThirdParties?.length >
                    0)
            ) && (
                <InfoSection isGrey={true}>
                    <Box>
                        {Boolean(
                            (
                                softwareProductWording?.softwareProductWordingAdditionalUses ||
                                []
                            )?.length > 0
                        ) ? (
                            <>
                                <Heading fontSize="md" mb={2}>
                                    Additional uses of your data
                                </Heading>

                                {softwareProductWording?.softwareProductWordingAdditionalUses?.map(
                                    (au: any) => {
                                        // @ts-ignore
                                        const isChecked = additionalUses.includes(au?.id);
                                        return (
                                            <HStack key={au.id} justifyContent="space-between" mb={2}>
                                                <Text id={au?.id}>{au?.description}</Text>
                                                <Switch
                                                    size="lg"
                                                    aria-labelledby={au.id}
                                                    checked={isChecked}
                                                    onChange={() => {
                                                        updateAdditionalUses(!isChecked, au?.id);
                                                    }}
                                                />
                                            </HStack>
                                        );
                                    }
                                )}
                            </>
                        ) : null}
                        {Boolean(
                            (softwareProductWording?.softwareProductWordingThirdParties || [])
                                .length > 0
                        ) ? (
                            <>
                                <Divider my={3}/>

                                <Heading fontSize="md" mb={2}>
                                    Supporting third parties
                                </Heading>
                                <Text>
                                    {softwareProductWording?.paragraphSupportingThirdParties}
                                </Text>

                                <OutsourcedProvidersPopUp
                                    showPopup={PopupOutsourcedProviders}
                                    handleClose={() => setPopUpOutsourcedProviders(false)}
                                />
                                <Button
                                    mt={2}
                                    variant="link"
                                    onClick={() => {
                                        setPopUpOutsourcedProviders(true);
                                    }}
                                >
                                    See list of providers
                                </Button>
                            </>
                        ) : null}
                    </Box>
                </InfoSection>
            )}
            <InfoSection>
                <Box>
                    <Box mb={4}>
                        <Heading fontSize="lg" fontWeight="bold" mb={3}>
                            Key dates
                        </Heading>
                        <Heading fontSize="sm" fontWeight="bold" mb={2}>
                            Sharing period
                        </Heading>

                        <Text>{`${formatDate(consent?.startTime)} - ${formatDate(
                            consent?.endTime
                        )}`}</Text>
                    </Box>

                    <Heading fontSize="sm" mb={2}>
                        How often we'll access your data
                    </Heading>
                    <Text>{softwareProductWording?.paragraphHowOftenDataAccessed}</Text>
                </Box>
            </InfoSection>

            <InfoSection isGrey={true}>
                <Box>
                    <Heading fontSize="md" mb={3}>
                        What happens to your data once we have used it
                    </Heading>

                    {/* De-identification of data */}
                    {Boolean(softwareProductWording?.canDeIdentifyData) ? (
                        <>
                            <Box mb={4}>
                                <Heading fontSize="sm" mb={2}>
                                    De-identification of data
                                </Heading>
                                <Text>{softwareProductWording?.paragraphDeIdentification}</Text>

                                <DeIdentificationPopUp
                                    showPopup={PopupDeIdentification}
                                    handleClose={() => setPopupDeIdentification(false)}
                                />
                                <Button
                                    mt={2}
                                    variant="link"
                                    onClick={() => {
                                        setPopupDeIdentification(true);
                                    }}
                                >
                                    How and why we de-identify data
                                </Button>
                            </Box>
                            <HStack mb={2} justifyContent="space-between">
                                <Heading fontSize="sm" id="DeleteMyData">
                                    Delete my data instead
                                </Heading>
                                <Switch
                                    size="lg"
                                    checked={deleteData}
                                    onChange={() => setDeleteData(!deleteData)}
                                    aria-labelledby="DeleteMyData"
                                />
                            </HStack>

                            <Text>{softwareProductWording?.paragraphDataDeletion}</Text>
                        </>
                    ) : (
                        <>
                            <Text>Your data will be deleted</Text>
                            {/* <p>{data === null ? "" : softwareProductWording?.paragraphDeleteMyData}</p> */}
                        </>
                    )}

                    <DataDeletionPopUp
                        showPopup={PopupDataDeletion}
                        handleClose={() => setPopupDataDeletion(false)}
                    />

                    <Button
                        mt={2}
                        variant="link"
                        onClick={() => {
                            setPopupDataDeletion(true);
                        }}
                    >
                        See how we delete your data
                    </Button>
                </Box>
            </InfoSection>

            <InfoSection>
                <Box>
                    <Box mb={4}>
                        <Heading fontSize="md" mb={3}>
                            Managing your data
                        </Heading>
                        <Heading fontSize="sm" mb={2}>
                            Where to manage this arrangement
                        </Heading>
                        <Text>{softwareProductWording?.paragraphWhereToManage}</Text>
                    </Box>

                    <Heading fontSize="sm" mb={2}>
                        If you want to stop sharing this data
                    </Heading>

                    <Text>{softwareProductWording?.paragraphStopSharingData}</Text>
                </Box>
            </InfoSection>

            <InfoSection isGrey={true}>
                <>
                    <Box pb={3}>
                        <Heading fontSize="sm" mb={2}>
                            Do you consent to share this data with us?
                        </Heading>

                        <Text>
                            Selecting 'I consent' won't give us access to your data just yet.
                            We will need to connect you with your bank to confirm this
                            decision
                        </Text>
                    </Box>

                    {Boolean(hasRequired && !selectedData) && (
                        <Box pb={3}>
                            <Alert borderWidth={1} borderRadius="md" status="warning">
                                <AlertIcon/>
                                {softwareProductWording?.paragraphRequiredConsentWarning}
                            </Alert>
                        </Box>
                    )}

                    <CancelContinueButtons
                        OnclickContinue={() => saveData()}
                        btnContinueText="I Consent"
                        btnCancelText="I Don't Consent"
                        btnDisableContinue={!selectedData}
                        popoverContent="Please select the data you would like to share."
                        step="DataRequest"
                    />
                </>
            </InfoSection>
        </PageLayoutWithGetData>
    );
}
